<template>
    <div class="recommend-doctor">
      <cube-scroll
        ref="scroll"
        :data="items"
        :options="options"
        @pulling-down="onPullingDown"
        @pulling-up="onPullingUp" class="page_scroll">
        <ul class="recommend-list">
            <li class="recommend-item" v-for="(item , index) in doctorList" :key="index">
               <img :src="item.photo" alt=""> 
               <div class="content-box">
                   <p>
                       <span>姓名：</span><span>{{item.name}}</span>
                   </p>
                   <p>
                       <span>所属医院：</span><span>{{item.hospital}}</span>
                   </p>
                   <p>
                       <span>所属科室：</span><span>{{item.desk}}</span>
                   </p>
                   <p>
                       <span>手机号码：</span><span>{{item.phone}}</span>
                   </p>
               </div>
            </li>
        </ul>
      </cube-scroll>
    </div>
</template>
<script>
export default {
  name: 'recommendDoctor',
  data (){
    return {
      user_id: localStorage.getItem('user_id'),
      doctorList: [],
      items:[],
      pageNum: 1,
      allpage: null,
      options: {
        pullUpLoad: {
          threshold: 60,
          txt: {
            more: '加载更多',
            noMore: '没有更多了'
          },
          visible: false
        },
        pullDownRefresh: {
          threshold: 60,
          txt: '刷新成功'
        },
      },
    }
  },
  created(){
    this.getInit(1, 1)
  },
  methods: {
    getInit(pageNum, type){
      let _this = this
      this.$http.api.findDoctorList({
        user_id: this.user_id,
        page: 1,
        size: 10
      }).then(result => {
        _this.allpage = Math.ceil(result.total/10)
        let data = result.rows
        // console.log(result)
         if (type === 1) {
          _this.doctorList = [...data]
          _this.$refs.scroll.forceUpdate()
          _this.pageNum = 2
        } else {
        //   console.log(_this.pageNum,_this.allpage)
          if (data.length > 0 && _this.pageNum <= _this.allpage) {
             _this.doctorList = _this.doctorList.concat(data)
            _this.pageNum = _this.pageNum + 1
            setTimeout(function () {
              _this.$refs.scroll.forceUpdate()
            }, 300)
          }else {
            //  console.log(2)
          }
        }
      })
      if( _this.pageNum > _this.allpage){
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }
    },
    onPullingDown () {
      // this.isLoading = false
      this.getInit(1,1)
    },
    onPullingUp () {
      let _this = this
      setTimeout(function () {
        _this.getInit( _this.pageNum,2)
      }, 800)
    },
  }
}
</script>
<style lang="less" scoped>
.recommend-doctor{
  width: 100%;
  .recommend-list{
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 10px;
    .recommend-item {
      background: #fff;
      height: 118px;
      border: 1px solid #DADEE1;
      margin-bottom: 10px;
      padding: 12px 20px;
      box-sizing: border-box;
      img{
          width: 90px;
          height: 90px;
          float:left;
          margin-right: 10px;
      }
      .content-box{
        width:60%;
        float: left;
        p{
          font-size:12px;
          color: #666;
          line-height:23px ;
        //   height:;
        }
      }
    }
  }
}
</style>

